import initialState from "reducers/initialState";
import * as actionTypes from "./actionTypes";
import { combineReducers } from "redux";
import { assetEquipmentsSchema } from "./schemas";
import { normalize } from "normalizr";
import { merge } from "lodash";

const configuratorHierarchyReducer = (state = initialState.asset.configurator.hierarchy, action) => {
  switch (action.type) {
    case actionTypes.LOAD_CONFIGURATOR_HIERARCHY_LEVEL_SUCCESS: {
      return {
        ...state,
        [action.payload.level]: {
          ...action.payload
        },
        loaded: true
      };
    }
    default:
      return state;
  }
};

const configuratorDataReducer = (state = initialState.asset.configurator.data, action) => {
  switch (action.type) {
    case actionTypes.LOAD_ASSET_BASE_PRICE_SUCCESS: {
      return {
        ...state,
        basePrice: action.payload.basePrice
      };
    }
    case actionTypes.INVALIDATE_CONFIGURATOR_DATA: {
      return {
        ...state,
        basePrice: null
      };
    }
    default:
      return state;
  }
};

const configuratorEquipmentsReducer = (state = initialState.asset.configurator.equipments, action) => {
  switch (action.type) {
    case actionTypes.LOAD_ASSET_EQUIPMENTS_STARTED: {
      return {
        ...state,
        [action.id]: {
          loading: true,
          loaded: false
        }
      };
    }
    case actionTypes.LOAD_ASSET_EQUIPMENTS_SUCCESS: {
      const { entities, result } = normalize(action.payload.equipments, [assetEquipmentsSchema]);
      const mergedState = merge({}, state, entities);

      const finalState = {
        ...mergedState,
        [action.id]: {
          loading: false,
          loaded: true,
          ids: result
        }
      };
      return finalState;
    }
    default:
      return state;
  }
};

const assetConfiguratorReducer = combineReducers({
  hierarchy: configuratorHierarchyReducer,
  data: configuratorDataReducer,
  equipments: configuratorEquipmentsReducer
});

export default assetConfiguratorReducer;
